import React, { ReactElement } from "react";
import classnames from "classnames";
import "./section.css";
import "./section-responsive.css";

export interface ISectionProps {
    children?: ReactElement | ReactElement[];
    headerText?: string;
    required?: boolean;
    className?: string;
    testId?: string;
}

const section = ({
    children,
    headerText,
    required,
    className,
    testId,
}: ISectionProps): ReactElement => {
    return (
        <div
            className={classnames("form-section", className)}
            {...(testId ? { "data-testid": testId } : {})}
        >
            {className === "owner-telematics-header" && (
                <div className="form-section-header-owner-telematics">
                    <span>{headerText}</span>
                </div>
            )}
            {headerText && className != "owner-telematics-header" && (
                <div className="form-section-header">
                    {required && <span className="red-star">*</span>}
                    <span>{headerText}</span>
                </div>
            )}
            <div className="form-section-children">{children}</div>
        </div>
    );
};

export default section;
